module.exports = __webpack_public_path__ + "0ce30f8a35411d58e330c5d9ff0ff6f3.png";